var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.loading,"absolute":""}},[_c('div',{staticClass:"d-flex flex-column align-center justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","width":5,"color":"primary"}}),_c('span',{staticClass:"my-4 loading-text"},[_vm._v(_vm._s(_vm.message || "กำลังโหลดข้อมูล"))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }